/* eslint-disable */
import { useContext, useState } from "react";

import { LocalizationContext } from "../../App";
import { Formatters } from "../../common/helpers/formatters";
import { ChevronCompactDown, ChevronCompactUp } from "../../common/icons";
import { ProductContext } from "../../context/ProductContext";
import { PolicyWithStatusDefinition } from "../../models/policy";
import { DocumentList } from "../document/DocumentList";
import { PolicyStatus } from "../../models/enum/PolicyStatus";
import StatusIndicator from "../common/StatusIndicator";

type PolicyCardProps = {
  policy: PolicyWithStatusDefinition;
};

export const PolicyCard = ({ policy }: PolicyCardProps) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const l10n = useContext(LocalizationContext);
  const { ppi, productIdToTypeKeyDict } = useContext(ProductContext);

  const numberOfInstallmentsToPaymentFrequencyString: Record<number, string> = {
    1: l10n.label.yearly,
    2: l10n.label.halfYearly,
    4: l10n.label.quarterly,
  };

  const subStatusDefinition = policy.statusDefinition.subStatusDefinition.find(
    (ssd) => ssd.code === policy.subStatusId
  );

  return (
    <div className="card">
      <div className="card-header block pb-4">
        <h3 className="!mb-1 flex-auto overflow-hidden whitespace-normal break-words font-semibold">
          {l10n.products[productIdToTypeKeyDict[policy.productTypeId]].name}
        </h3>
        {subStatusDefinition?.name && (
          <StatusIndicator
            status={policy.statusId === 2 ? "success" : "pending"} // Policy = success, Offer = pending
            title={subStatusDefinition.name}
          />
        )}
      </div>

      <div className="card-body pt-2">
        <div className="grid grid-cols-2 gap-2 text-sm">
          <div className="flex flex-col">
            <span className="text-sm">{l10n.label.premium}</span>
            <span className="font-semibold">
              {typeof policy.netPrice === "number"
                ? Formatters.formatCurrencyNumber(policy.netPrice)
                : "N/A"}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="text-sm">{l10n.label.desiredPaymentFrequency}</span>
            <span className="font-semibold">
              {numberOfInstallmentsToPaymentFrequencyString[policy.numberOfInstallments]}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="text-sm">{l10n.label.validFrom}</span>
            <span className="font-semibold">
              {policy.validFromDate ? Formatters.formatShortDate(policy.validFromDate) : "N/A"}
            </span>
          </div>

          {policy.productTypeId !== ppi && (
            <div className="flex flex-col">
              <span className="text-sm">{l10n.label.validTo}</span>
              <span className="font-semibold">
                {policy.validToDate ? Formatters.formatShortDate(policy.validToDate) : "N/A"}
              </span>
            </div>
          )}

          <div className="flex flex-col">
            <span className="text-sm">
              {policy.productTypeId === ppi
                ? l10n.label.coverageAmountPPI
                : l10n.label.coverageAmountDI}
            </span>
            <span className="font-semibold">
              {Formatters.formatCurrencyNumber(policy.policyCalculationDetails.CoverageAmount)}
            </span>
          </div>
        </div>
      </div>

      {isExpanded && (
        <div className="p-4">
          <div className="font-semibold mb-1">{l10n.policy.yourDocuments}</div>
          <div className="grid gap-4 text-sm">
            <DocumentList entityType="Policy" entityIdentifier={policy.uniqueIdentifier} />
          </div>
        </div>
      )}
      {!(policy.statusId === PolicyStatus.Offer && ![2, 23].includes(policy.subStatusId)) && (
        <div className="flex justify-center items-center">
          <button onClick={() => setIsExpanded(!isExpanded)}>
            <span>
              {isExpanded ? (
                <ChevronCompactUp className={"w-6 h-6"} />
              ) : (
                <ChevronCompactDown className={"w-6 h-6"} />
              )}
            </span>
          </button>
        </div>
      )}
    </div>
  );
};
